// extracted by mini-css-extract-plugin
module.exports = {"iconSymbol":"pages-iconSymbol-1X-rU","letterSymbol":"pages-letterSymbol-1hMGR"};